module.exports = __webpack_public_path__ + "img/img-premium_admin_banner_chatbotnow.d0268a18.png";